export default __webpack_public_path__ + "static/media/tokenmetricV2Mb.ef83e60e.png";